import PropTypes from 'prop-types'
import { VictoryChart, VictoryAxis, VictoryBar, VictoryTheme } from 'victory'
import { makeStyles, useTheme } from 'beam/dist/styles'
import AssociatedContactBar from './AssociatedContactBar'

const useStyles = makeStyles(() => ({
  svg: {
    display: 'block',
  },
}))

const clearStyle = { stroke: 'none', fill: 'none' }

const AssociatedContactsGraph = props => {
  const { associatedContacts, selectedContactId, width, height, openContact, heightPerContact } = props
  const theme = useTheme()
  const classes = useStyles()
  const chartData = mapContactsToBarChartData()

  function mapContactsToBarChartData() {
    const { associatedContacts, selectedContactId } = props
    const unselectedColor = theme.palette.grey[400]
    const selectedColor = theme.palette.color.lightBlue[800]

    const minStartTime = associatedContacts.reduce(
      (minTime, { startTime }) => Math.min(startTime, minTime),
      Number.MAX_SAFE_INTEGER,
    )

    return associatedContacts.map((contact, i) => {
      const { id, startTime, callDuration } = contact
      const relativeStartTime = startTime - minStartTime

      return {
        label: '',
        fill: id === selectedContactId ? selectedColor : unselectedColor,
        x: associatedContacts.length - i,
        y: relativeStartTime + callDuration,
        y0: relativeStartTime,
        contact,
      }
    })
  }

  const desiredHeight = Math.min(height, associatedContacts.length * heightPerContact * 1.25)
  const barPadding = (desiredHeight || 1) / (associatedContacts.length || 1) / 2

  return (
    <svg width={width} height={desiredHeight} className={classes.svg}>
      <VictoryChart
        horizontal
        theme={VictoryTheme.material}
        standalone={false}
        width={width}
        height={desiredHeight}
        domainPadding={{ x: [0, 0], y: [0, 0] }}
        padding={{ top: barPadding, bottom: barPadding, left: heightPerContact, right: 0 }}
      >
        {/* This removes axes from the graph */}
        <VictoryAxis
          dependentAxis
          style={{
            axis: clearStyle,
            axisLabel: clearStyle,
            grid: clearStyle,
            ticks: clearStyle,
            tickLabels: clearStyle,
          }}
        />
        <VictoryBar
          data={chartData}
          horizontal={true}
          barWidth={heightPerContact / 4}
          style={{
            data: {
              fill: ({ datum }) => datum.fill,
            },
          }}
          events={[
            {
              target: 'data',
              eventHandlers: {
                onClick: () => [
                  {
                    target: 'data',
                    mutation: ({ datum: { contact } }) =>
                      contact.id !== selectedContactId && contact.inScope ? openContact(contact.id) : () => {},
                  },
                ],
              },
            },
          ]}
          dataComponent={
            <AssociatedContactBar
              heightPerContact={heightPerContact}
              selectedContactId={selectedContactId}
              openContact={openContact}
            />
          }
        />
      </VictoryChart>
    </svg>
  )
}
AssociatedContactsGraph.propTypes = {
  associatedContacts: PropTypes.array.isRequired,
  selectedContactId: PropTypes.number,
  width: PropTypes.number.isRequired,
  height: PropTypes.number.isRequired,
  openContact: PropTypes.func.isRequired,
  heightPerContact: PropTypes.number,
}
AssociatedContactsGraph.defaultProps = {
  selectedContactId: null,
  heightPerContact: 24,
}

export default AssociatedContactsGraph
